import { ReactElement } from 'react';
import { AlertTriangle, CircleX, Info } from 'lucide-react';

import { NoticeVariant } from './context';

/**
 * The icon `Notice.Icon` falls back to when given no children, so the
 * variant-to-icon pairing stays in one place rather than at each call site.
 *
 * Single elements, for the same reason `NoticeIconProps` requires one: the
 * class is slotted onto the icon rather than a wrapper.
 */
export const DefaultIcons: Record<
  NoticeVariant,
  ReactElement<{ className?: string }>
> = {
  info: <Info />,
  warning: <AlertTriangle />,
  danger: <CircleX />,
};
